var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Radio Button"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Radio Button_2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bg",
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#635BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Active",
    x: 3,
    y: 3,
    width: 10,
    height: 10,
    rx: 5,
    fill: "#635BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenright);
export default __webpack_public_path__ + "static/media/greenright.4f09f5c1.svg";
export { ForwardRef as ReactComponent };